/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useGesture } from "@use-gesture/react";
import create from "zustand";
import { useResizeDetector } from "react-resize-detector";
import { HotspotController } from "./components/HotspotController";
import Renderer from "./pages/Renderer";
import useAppStore from "./AppStore";
import SMController from "./components/SMController";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "rc-slider/assets/index.css";
import "rc-collapse/assets/index.css";
import "./index.scss";
import { Configurator } from "./components/Configurator";
import { API_CONFIG } from "./config/api.config";
import ThreejsScene from "./modules/ThreejsScene";

const store = (set) => ({
  modeListner: (data) => {
    console.log("rendererMode", data);
  },
  bindGestureListner: (data) => {
    console.log(data);
  },
  setModeListner: (modeListner) => set({ modeListner }),
  setGestureListner: (bindGestureListner) => set({ bindGestureListner }),
});

export const useListnerStore = create(store);

if (!API_CONFIG.ENABLE_LOGS) console.log = () => {};

const App = () => {
  const { width, height, ref } = useResizeDetector();
  const aspectRatio = useAppStore((state) => state.aspectRatio);
  const appMode = useAppStore((state) => state.appMode);
  const [additionalConfig, setadditionalConfig] = useState({});

  const bindListner = useListnerStore((state) => state.bindGestureListner);
  const modeListner = useListnerStore((state) => state.modeListner);

  const bindListnerFunction = (data) => {
    console.log("maindata", data);
    bindListner(data);
  };

  useGesture(
    {
      onDrag: (data) => bindListner(data),
    },
    additionalConfig
  );

  useEffect(() => {
    if (document.getElementById("SCENEAR")) {
      setadditionalConfig({ target: document.getElementById("SCENEAR") });
    }
  }, [bindListner]);

  useEffect(() => {
    if (width || height) {
      ThreejsScene.canvasResizeContainer();
      ThreejsScene.divresize();
    }
  }, [aspectRatio, width, height]);

  useEffect(() => {
    const abc = () => {
      const x = new URLSearchParams(window.location.search).get("ar");
      modeListner(x);
    };
    window.addEventListener("popstate", abc);
    return () => window.removeEventListener("popstate", abc);
  }, [modeListner]);

  const [screenheight, setScreenheight] = useState(window.screen.availHeight);
  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenheight(window.screen.availHeight);
    });
    return () => {
      window.removeEventListener("resize", () => {
        setScreenheight(window.screen.availHeight);
      });
    };
  }, []);

  console.log("rendering app", appMode, aspectRatio, aspectRatio);

  const getRenderer = () => {
    if (appMode === "engine") {
      return (
        <div
          className="rendererContainer"
          style={{
            aspectRatio: `auto ${aspectRatio}`,
          }}
          id="RENDERER"
          ref={ref}
        >
          <canvas id="SCENE" className="SCENE-engine" />
          <Renderer />
        </div>
      );
    }
    return (
      <>
        <canvas id="SCENE" className="SCENE" />
        <Renderer />
      </>
    );
  };

  return (
    <div
      className="app"
      style={appMode === "renderer" ? { height: screenheight } : {}}
    >
      {appMode === "engine" && (
        <div className="engine">
          <Configurator />
        </div>
      )}
      <div className={appMode === "engine" ? "renderer-engine" : "renderer"}>
        <SMController />
        <HotspotController />
        {getRenderer()}
      </div>
    </div>
  );
};

export default App;
